import {TheRaveLayers, Layers} from "../view/TheRaveLayers";
import {TimelineLite, TweenLite, Power3} from "gsap";
import {TheRave} from "../TheRave";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {TheRaveReelView} from "./TheRaveReelView";
import {TheRaveGameConfig} from "../TheRaveGameConfig";

export class TheRaveEnhancerReelView extends TheRaveReelView {
    public symId: number;
    public glow: TimelineSprite;
    public spotlight: PIXI.spine.Spine;
    public pinkEnhance: TimelineSprite;
    public enhanceSymbolLandEffect: PIXI.spine.Spine;
    public smoke: PIXI.spine.Spine;
    public frame: PIXI.Sprite;
    public _offset: number = 0;
    private _isLocked: boolean = true;
    private _isFreeSpin: boolean = false;
    private _wasActive:boolean = false;
    private readonly SMOKE_TINT: number[] = [0x000000, 0x2639E9, 0x26E9E2, 0x9C00FF, 0xFF0090, 0xFFF000];

    public set isLocked(value: boolean) {
        if (this._isLocked === value) {
            return;
        }
        this._isLocked = value;
        this._highContainer.visible = !value;
        if (this.frame) {
            TweenLite.to(this.frame.scale, 0.3, {y: 1});
            if(TheRave.model.isFreespin){
                TweenLite.to(this.frame, 0.3, {y: TheRaveEnhancerReelView.REEL_TOP + TheRaveEnhancerReelView.SYMBOL_HEIGHT * (this.symId - 1)+75});
            }
        }
    }

    public set size(value: number) {
        if (!this.glow) {
            return;
        }
        if (this.frame.scale.y === value) {
            return;
        }
        TweenLite.to(this.frame.scale, {y: value, duration: 0.2});
    }

    public set isFreeSpin(value: boolean) {
        this._offset = (value ? 70 : 0);
        this._isFreeSpin = value;
    }

    public get isLocked(): boolean {
        return this._isLocked;
    }

    constructor(reelId: number) {
        super(reelId);
        this.symId = -1;
        this.isLocked = true;
        this._highContainer.visible = false;
        TheRaveLayers.getLayer(Layers.HIGH_SYMBOLS)!.removeChild(this._highContainer);
        TheRaveLayers.getLayer(Layers.ENHANCER_SYMBOLS)!.addChild(this._highContainer);

        //this.setPosition(3);
        //this.playUnLock(3);
        //this.tmpDebugHandler();
    }

    private tmpDebugHandler(): void {
        const ref = this;
        document.addEventListener("keydown", function (e) {
            var keyCode = e.keyCode;
            //console.log("KeyCode: " + keyCode);

            switch (keyCode) {
                case 48:
                    break; // 0
                case 49:
                    ref.enhancerFrameTester();
                    break; // 1
                case 50:
                    break; // 2
                case 51:
                    break; // 3
                case 52:
                    break; // 4
                case 53:
                    break; // 5
                case 54:
                    break; // 6
                case 55:
                    break; // 7
                case 56:
                    break; // 8
                case 57:
                    break; // 9
            }
        }, false);
    }

    private removeEffects(): void {
        if (!this._isFreeSpin) {
            if (this.frame) {
                this.frame.visible = false;
            }
        }
        if (this.glow) {
            this.glow.visible = false;
            this.glow.stopLoop();
        }
        if (this.pinkEnhance) {
            this.pinkEnhance.visible = false;
            this.pinkEnhance.stopLoop();
        }
        this.removeSpine(this.smoke, Layers.ENHANCER_REEL);
        this.removeSpine(this.spotlight, Layers.ENHANCER_REEL_EFFECTS);
    }

    private createFrame(): void {
        if (this.frame) {
            this.frame.scale.set(1, 1);
            return;
        }
        this.frame = new PIXI.Sprite(TheRave.assetLoader.getTextures(`FSSFS/enhancers`)[0]);
        this.frame.blendMode = PIXI.BLEND_MODES.ADD;
        this.frame.anchor.set(0.5, 0.5);
        this.frame.name = `frame${this.reelId}`;
    }

    private createGlow(): void {
        if (this.glow) {
            return;
        }
        this.glow = new TimelineSprite(TheRave.assetLoader.getTextures(`spGlow`), 60);
        this.glow.blendMode = PIXI.BLEND_MODES.ADD;
        this.glow.anchor.set(0.5, 0.5);
        this.glow.name = `glow${this.reelId}`;
    }

    private createPinkAttention(): void {
        if (this.pinkEnhance) {
            return;
        }
        this.pinkEnhance = new TimelineSprite(TheRave.assetLoader.getTextures(`pinkEnhance`), 60);
        this.pinkEnhance.blendMode = PIXI.BLEND_MODES.ADD;
        this.pinkEnhance.anchor.set(0.5, 0.5);
        this.pinkEnhance.name = `pinkEnhance${this.reelId}`;
        this.pinkEnhance.tint = 0xEA00FF;
        this.pinkEnhance.alpha = 0.4;
    }

    private setAnimationPosition(): void {
        TheRaveLayers.getLayer(Layers.ENHANCER_REEL_EFFECTS)?.addChild(this.frame);
        TheRaveLayers.getLayer(Layers.ENHANCER_REEL_EFFECTS)?.addChild(this.glow);
        TheRaveLayers.getLayer(Layers.ENHANCER_REEL_EFFECTS)?.addChild(this.pinkEnhance);
        const x: number = this._highContainer.position.x,
            y: number = TheRaveEnhancerReelView.REEL_TOP + TheRaveEnhancerReelView.SYMBOL_HEIGHT * (this.symId - 1);
        this.frame.position.set(x, y + 75);
        this.glow.position.set(x, y + 75);
        this.pinkEnhance.position.set(x, y);

        if (this.smoke) {
            TheRaveLayers.getLayer(Layers.ENHANCER_REEL)?.addChild(this.smoke);
            this.smoke.position.set(x, y + 75);
        }
    }

    private addSpine(name: string, id: number): PIXI.spine.Spine {
        const spine: PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(name));
        spine.name = `${name}R${this.reelId}S${id}`;
        spine.autoUpdate = true;
        spine.position.set(0, 0);
        spine.visible = false;
        return spine;
    }

    private removeSpine(spine: PIXI.spine.Spine, layerName: string): void {
        if (spine) {
            spine.visible = false;
            TheRaveLayers.getLayer(layerName)?.removeChild(spine);
        }
    }

    public show(): void {
    }

    public playUnLock(i: number): void {
        if (!this.isLocked) {
            return;
        }
        this.isLocked = false;
        this.playUnLockGlow(i);
    }

    public setPosition(symId: number): void {
        this.symId = symId;
        this._highContainer.position.y = TheRaveEnhancerReelView.REEL_TOP + TheRaveEnhancerReelView.SYMBOL_HEIGHT * (symId - 1);
    }

    public showEnhancerPositionsBeforeFS(): TimelineLite {
        if (this.symId < 0) {
            return new TimelineLite();
        }
        //drop reelarea to bottom symbol
        const endPos: number = TheRaveEnhancerReelView.REEL_TOP + TheRaveEnhancerReelView.SYMBOL_HEIGHT * 2 + this._offset;
        const dropDuration: number = ((this._highContainer.position.y === endPos) ? 0 : 0.5);
        const isTopSymbol: boolean = (this.symId===1);
        const dropDwonAnimation:PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(isTopSymbol?"DOWNTWO":"DOWNONE"));
        dropDwonAnimation.name = `${isTopSymbol?"DOWNTWO":"DOWNONE"}`;
        TheRaveLayers.getLayer(Layers.ENHANCER_REEL_EFFECTS)?.addChild(dropDwonAnimation);
        const x: number = this._highContainer.position.x,
            y: number = TheRaveEnhancerReelView.REEL_TOP + TheRaveEnhancerReelView.SYMBOL_HEIGHT * (this.symId);
        dropDwonAnimation.position.set(x, y + (isTopSymbol?225:75));
        return new TimelineLite().add(()=>{
            if(this.symId<3){
                dropDwonAnimation.state.setAnimation(0,isTopSymbol?"X3":"X2", false);
            }
        }).add(()=>{
            dropDwonAnimation.visible = false;
            TheRaveLayers.getLayer(Layers.ENHANCER_REEL_EFFECTS)?.removeChild(dropDwonAnimation);
            }, dropDuration);
    }

    public enhancerFrameTester():void {
        this.createFrame();
        this.createGlow();
        this.createPinkAttention();
        this.frame.visible = true;
    }

    public playUnLockGlow(i: number) {
        if (this.symId < 0) {
            return;
        }

        if (this.hasStopped) {
            return;
        }
        const x = TheRaveEnhancerReelView.REEL_AREAS[this.reelId].x;
        const y = this._highContainer.position.y;

        this.createFrame();
        this.createGlow();
        this.createPinkAttention();
        this.frame.visible = this.isFreeSpin;
        TheRaveLayers.getLayer(Layers.ENHANCER_REEL_EFFECTS)?.addChild(this.glow);
        TheRaveLayers.getLayer(Layers.ENHANCER_REEL_EFFECTS)?.addChild(this.pinkEnhance);
        //this.spotlight.scale.x = i%2===0?1:-1;
        if (TheRave.model.currentParsedData.mode === GameMode.NORMAL) {
            this.smoke = this.addSpine(`scatterSMOKE`, i);
            TheRaveLayers.getLayer(Layers.ENHANCER_REEL)?.addChild(this.smoke);

            this.spotlight = this.addSpine(`spotLight`, i);
            TheRaveLayers.getLayer(Layers.ENHANCER_REEL_EFFECTS)?.addChild(this.spotlight);
            this.spotlight.position.set(x, y);
            this.spotlight.state.setAnimation(0, `${i === 0 ? "A" : (i % 2 === 0 ? "B" : "C")}${this.symId === 1 ? "Down" : "Up"}`, true);
            this.spotlight.visible = true;
        }

        this.setAnimationPosition();

        if (TheRave.model.currentParsedData.mode === GameMode.NORMAL) {
            this.smoke.state.setAnimation(0, `${Math.floor(Math.random() * 5)}`, true);
            this.smoke.visible = true;
        }
        this.glow.playLoop();
        this.glow.visible = true;
        this.pinkEnhance.playLoop();
        this.pinkEnhance.visible = true;
        TheRave.fullScreenDimLayer.startReelAreaDimmer();
    }

    public hideAnimation(): TimelineLite {
        return new TimelineLite().add(
            () => {
                this.removeEffects();
                const x = TheRaveEnhancerReelView.REEL_AREAS[this.reelId].x;
                const y = this._highContainer.position.y;
                this.enhanceSymbolLandEffect = this.addSpine(`scatterAchievement`, 0);
                TheRaveLayers.getLayer(Layers.ENHANCER_REEL_EFFECTS)?.addChild(this.enhanceSymbolLandEffect);
                this.enhanceSymbolLandEffect.position.set(x, y + 75);
                this.enhanceSymbolLandEffect.state.setAnimation(0, `2`, false);
                this.enhanceSymbolLandEffect.visible = true;
            }).add(() => {
            this.hasStopped = true;
            TheRave.fullScreenDimLayer.stopReelAreaDimmer();
            if (this.enhanceSymbolLandEffect) {
                this.enhanceSymbolLandEffect.visible = false;
                TheRaveLayers.getLayer(Layers.ENHANCER_REEL_EFFECTS)?.removeChild(this.enhanceSymbolLandEffect);
            }
        }, 2);
    }

    public startSpin(): void {
        this.hasStopped = false;
    }


    protected doBounce(): void {
        super.doBounce();
        this.hasStopped = true;
        if(TheRave.model.currentParsedData.enhancerReel[this.reelId-5]){

            this.hideAnimation();
        }
    }

    public playXwayAttentionInFS(symId:number = 2): void {
        if(TheRave.model.parsedGameData.isFreespin) {
            if(this.frame) {
                this.frame.visible = false;
                this._wasActive = true;
            }
            TheRave.xwaysEqView.playXwayGlow(this.reelId, () => {}, true, symId);
        }
    }

    public xWayAttentionComplete(): void {
        if(this._wasActive) {
            this.frame.visible = true;
            this._wasActive = false;
        }
    }

    public hide(): void {
        this.isLocked = true;
        TheRave.fullScreenDimLayer.stopReelAreaDimmer();
        this.removeEffects();
    }

    public updateGlow(isActive: boolean): void {
        this.isLocked = !isActive;
        if (isActive) {
            this.setPosition(3);
            this.createFrame();
            this.createGlow();
            this.createPinkAttention();
            this.setAnimationPosition();
            this.glow.playLoop();
            this.pinkEnhance.playLoop();
            this.frame.visible = true;
            this.glow.visible = true;
            this.pinkEnhance.visible = true;
        } else {
            if (this.frame) {
                this.frame.visible = false;
            }

            if (this.glow) {
                this.glow.stopLoop();
                this.glow.visible = false;
            }
            if (this.pinkEnhance) {
                this.pinkEnhance.stopLoop();
                this.pinkEnhance.visible = false;
            }
            if (this.smoke) {
                this.smoke.visible = false;
            }
        }
    }

    public scaleGlow(scale: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        if (!this.frame) {
            return tl;
        }
        const toY: number = this.frame.position.y + (1 - scale) * 75;
        tl.to(this.frame.position, {
            y: toY,
            duration: TheRaveGameConfig.REEL_ENGINE_CONFIG.DURATION.EXPAND!,
            ease: TheRaveGameConfig.REEL_ENGINE_CONFIG.EASING.EXPAND!
        }, 0.03);
        tl.to(this.frame.scale, {
            y: scale,
            duration: TheRaveGameConfig.REEL_ENGINE_CONFIG.DURATION.EXPAND!,
            ease: TheRaveGameConfig.REEL_ENGINE_CONFIG.EASING.EXPAND!
        });
        return tl;
    }
}